import script from "./StorePage.vue?vue&type=script&setup=true&lang=js"
export * from "./StorePage.vue?vue&type=script&setup=true&lang=js"

import "./StorePage.vue?vue&type=style&index=0&id=5a3139d9&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a3139d9"]])

export default __exports__